<template>
  <ElButton
    type="success"
    @click="showForm = true"
  >
    {{ title }}

    <ElDialog
      append-to-body
      :title="title | ucwords"
      top="25vh"
      :visible.sync="showForm"
    >
      <ElForm
        label-position="left"
        @submit.native.prevent
      >
        <ElInput
          v-model.trim="recruiterEmail"
          type="text"
          placeholder="Type the new recruiter's email"
          clearable
          @blur="$v.recruiterEmail.$touch()"
        />
      </ElForm>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <ElButton
          class="margin-right-unit"
          type="text"
          @click="showForm = false"
        >
          Cancel
        </ElButton>

        <ElButton
          type="primary"
          :disabled="$v.recruiterEmail.$invalid"
          @click="addRecruiter()"
        >
          Submit
        </ElButton>
      </span>
    </ElDialog>
  </ElButton>
</template>

<script>
import axios from '@/axios/axios'

import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'AddRecruiter',
  mixins: [ validationMixin ],
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showForm: false,
      recruiterEmail: null
    }
  },
  computed: {
    title() {
      return 'ADD RECRUITER'
    },

    profile() {
      return this.user.profile
    }
  },
  validations: {
    recruiterEmail: {
      required,
      email
    }
  },
  methods: {
    addRecruiter() {
      const data = {
        email: this.recruiterEmail,
        profile: {
          id: this.profile.id
        }
      }

      return axios.post('admin/recruiter/add', data)
        .then(res => {
          this.showForm = false

          this.successNotification(res.data)
        })
        .catch(axios.handleError)
    }
  }
}
</script>
